import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './components/Login';
// import UserLogin from './pages/UserLogin';
import Dashboard from './Admin/Dashboard'; // Example protected route
import Register from './components/Register';
import Home from './User/Home';
import AddTransactions from './User/AddTransactions';
import EditTransaction from './User/EditTransactions';
import UserTransactions from './Admin/UserTransactions';
import DailyTasks from './User/DailyTasks';
import AddDailyTasks from './User/AddDailyTasks';
import Store from './Admin/Store';
import AddStores from './Admin/AddStores';
import UserOperations from './Admin/UserOperations';
import ProtectedRoute from "./utils/ProtectedRoute"; // ✅ import the ProtectedRoute component

const App = () => {
  return (
    <Router>

      <Routes>
        {/* Public routes */}
        <Route path="/" element={<Register />} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />

        {/* Protected routes */}
        <Route path="/admin/dashboard" element={
          <ProtectedRoute><Dashboard /></ProtectedRoute>
        } />
        <Route path="/admin/store" element={
          <ProtectedRoute><Store /></ProtectedRoute>
        } />
        <Route path="/addStore" element={
          <ProtectedRoute><AddStores /></ProtectedRoute>
        } />
        <Route path="/userTransactions/:userId" element={
          <ProtectedRoute><UserTransactions /></ProtectedRoute>
        } />
        <Route path="/userOperations/:userId" element={
          <ProtectedRoute><UserOperations /></ProtectedRoute>
        } />
        <Route path="/user/home" element={
          <ProtectedRoute><Home /></ProtectedRoute>
        } />
        <Route path="/addtransactions" element={
          <ProtectedRoute><AddTransactions /></ProtectedRoute>
        } />
        <Route path="/user/dailytasks" element={
          <ProtectedRoute><DailyTasks /></ProtectedRoute>
        } />
        <Route path="/addDailytasks" element={
          <ProtectedRoute><AddDailyTasks /></ProtectedRoute>
        } />
      </Routes>

    </Router>
  );
};

export default App;

// {/* <Routes>
//         {/* Route for Admin Login */}
//         <Route path="/" element={<Register/>} />
//         <Route path="/register" element={<Register/>} />
//         <Route path="/login" element={<Login />} />
//         <Route path="admin/dashboard" element={<Dashboard />} />
//         <Route path="admin/store" element={<Store />} />
//         <Route path="/addStore" element={<AddStores />} />
//         <Route path="/userTransactions/:userId" element={<UserTransactions />} />
//         <Route path="/userOperations/:userId" element={<UserOperations />} />
//         <Route path="user/home" element={<Home />} />
//         <Route path="/addtransactions" element={<AddTransactions />} />
//         {/* <Route path="/editTransaction/:id" element={<EditTransaction />} /> */}
//         <Route path="user/dailytasks" element={<DailyTasks />} />
//         <Route path="/addDailytasks" element={<AddDailyTasks />} />
// </Routes> */}
